import React, { useMemo, useCallback } from 'react';
import compact from 'lodash/compact';

import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../types';

import {
  MultiSelectExtendedDataType,
  MultiSelectChangeCallbackType
} from '../../../../helpers/MultiSelect/types';

import { MultiSelect } from '../../../../helpers/MultiSelect';
import { Translate } from '../../../../helpers/Translate';
import { Icon } from '../../../../helpers/Icon';

import { operationsTypes } from '../../operationsConstants';

interface OperationsTypesMultiSelectProps {
  value: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
}

function OperationsTypesMultiSelect({
  value,
  autoFocus,
  onChange
}: OperationsTypesMultiSelectProps) {
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    return compact(
      operationsTypes.map(({ value, i18nLabel, icon }) => ({
        value: value,
        label: (
          <span className="flex items-center">
            <Icon icon={icon} className="h-5 w-5 mr-1" />
            <Translate id={i18nLabel} />
          </span>
        )
      }))
    );
  }, []);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default OperationsTypesMultiSelect;
